const getPagination = state => state.commentsPagination || {};
export const getCommentsPaginationConfig = state => getPagination(state).commentsPaginationConfig;
